import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "@utils/http";


export const getWebsiteSettings = createAsyncThunk(
  "byod/getWebsiteSettings",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await http.get("/byod/website-settings/");
      return data;
    } catch (e) {
      rejectWithValue({ e });
    }
  }
);
